module.exports = __webpack_public_path__ + "img/calendar_icon.8db39dd5.svg";